module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmh"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("To my beloved Mother Grace Okri 1936–1996")]), _vm._v(" "), _c('p', {
    staticClass: "poemtt"
  }, [_vm._v("Now that serenely")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("You rest on high")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Forgive your son")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Who couldn’t say goodbye")]), _vm._v(" "), _c('p', {
    staticClass: "poemt"
  }, [_vm._v("But Death was a tyrant")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("On the rich land")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And you had written")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Enigmas in my hand")]), _vm._v(" "), _c('p', {
    staticClass: "poemt"
  }, [_vm._v("The more they try")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("To press you down")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The more beautiful")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Grows your crown")]), _vm._v(" "), _c('p', {
    staticClass: "poemt"
  }, [_vm._v("And now that you")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Are as a spiritual dove")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Dwell forever")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("In our eternal love")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d02c685","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/003_Poem.vue
// module id = 72
// module chunks = 0